const PREFIX = 'ACCOUNT_INSURANCE_INFO_';

export const SET_LOADING = `${PREFIX}SET_LOADING`;
export const UNSET_LOADING = `${PREFIX}UNSET_LOADING`;
export const GET_INSURANCE_INFO_SUCCESS = `${PREFIX}GET_INSURANCE_INFO_SUCCESS`;